var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "privacy-requests" },
    [
      _c("div", { staticClass: "stats-row" }, [
        _c("div", { staticClass: "stat-card" }, [
          _c("span", { staticClass: "stat-value" }, [
            _vm._v(_vm._s(_vm.stats.abertas)),
          ]),
          _c("span", { staticClass: "stat-label" }, [_vm._v("Abertas")]),
        ]),
        _c(
          "div",
          {
            staticClass: "stat-card",
            class: { "stat-card--danger": _vm.stats.vencidas > 0 },
          },
          [
            _c("span", { staticClass: "stat-value" }, [
              _vm._v(_vm._s(_vm.stats.vencidas)),
            ]),
            _c("span", { staticClass: "stat-label" }, [_vm._v("Vencidas")]),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "stat-card",
            class: { "stat-card--warning": _vm.stats.vencendo > 0 },
          },
          [
            _c("span", { staticClass: "stat-value" }, [
              _vm._v(_vm._s(_vm.stats.vencendo)),
            ]),
            _c("span", { staticClass: "stat-label" }, [
              _vm._v("Vencendo em " + _vm._s(_vm.warningDays) + " dias"),
            ]),
          ]
        ),
        _c("div", { staticClass: "stat-card" }, [
          _c("span", { staticClass: "stat-value" }, [
            _vm._v(_vm._s(_vm.stats.acessos_30d)),
          ]),
          _c("span", { staticClass: "stat-label" }, [
            _vm._v("Acessos a dado sensível (30d)"),
          ]),
        ]),
      ]),
      _c("vx-card", [
        _c(
          "div",
          { staticClass: "filters-row" },
          [
            _c(
              "vs-select",
              {
                staticClass: "filter-field",
                attrs: { label: "Situação" },
                on: { input: _vm.load },
                model: {
                  value: _vm.filters.status,
                  callback: function ($$v) {
                    _vm.$set(_vm.filters, "status", $$v)
                  },
                  expression: "filters.status",
                },
              },
              [
                _c("vs-select-item", { attrs: { value: "", text: "Todas" } }),
                _c("vs-select-item", {
                  attrs: { value: "PE", text: "Pendente" },
                }),
                _c("vs-select-item", {
                  attrs: { value: "EP", text: "Em processamento" },
                }),
                _c("vs-select-item", {
                  attrs: { value: "CO", text: "Concluída" },
                }),
                _c("vs-select-item", {
                  attrs: { value: "RJ", text: "Recusada" },
                }),
              ],
              1
            ),
            _c(
              "vs-select",
              {
                staticClass: "filter-field",
                attrs: { label: "Tipo" },
                on: { input: _vm.load },
                model: {
                  value: _vm.filters.type,
                  callback: function ($$v) {
                    _vm.$set(_vm.filters, "type", $$v)
                  },
                  expression: "filters.type",
                },
              },
              [
                _c("vs-select-item", { attrs: { value: "", text: "Todos" } }),
                _vm._l(_vm.typeLabels, function (label, key) {
                  return _c("vs-select-item", {
                    key: key,
                    attrs: { value: key, text: label },
                  })
                }),
              ],
              2
            ),
            _c(
              "vs-checkbox",
              {
                staticClass: "filter-check",
                on: { input: _vm.load },
                model: {
                  value: _vm.filters.only_open,
                  callback: function ($$v) {
                    _vm.$set(_vm.filters, "only_open", $$v)
                  },
                  expression: "filters.only_open",
                },
              },
              [_vm._v(" Só as abertas ")]
            ),
          ],
          1
        ),
        _vm.loading
          ? _c("div", { staticClass: "state-message" }, [_vm._v("Carregando…")])
          : !_vm.rows.length
          ? _c("div", { staticClass: "state-message" }, [
              _vm._v(" Nenhuma requisição com estes filtros. "),
            ])
          : _c("table", { staticClass: "privacy-table" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", [_vm._v("Protocolo")]),
                  _c("th", [_vm._v("Titular")]),
                  _c("th", [_vm._v("Tipo")]),
                  _c("th", [_vm._v("Situação")]),
                  _c("th", [_vm._v("Prazo (Art. 19)")]),
                  _c("th", [_vm._v("Ações")]),
                ]),
              ]),
              _c(
                "tbody",
                _vm._l(_vm.rows, function (row) {
                  return _c(
                    "tr",
                    { key: row.id, class: { "row-overdue": row.is_overdue } },
                    [
                      _c("td", [_vm._v("#" + _vm._s(row.id))]),
                      _c("td", [
                        _c("div", { staticClass: "subject" }, [
                          _c("strong", [
                            _vm._v(_vm._s(row.user ? row.user.name : "—")),
                          ]),
                          _c("span", [
                            _vm._v(_vm._s(row.user ? row.user.email : "")),
                          ]),
                        ]),
                      ]),
                      _c("td", [_vm._v(_vm._s(row.type_label))]),
                      _c("td", [
                        _c(
                          "span",
                          {
                            staticClass: "pill",
                            class: _vm.statusClass(row.status),
                          },
                          [_vm._v(_vm._s(row.status_label))]
                        ),
                      ]),
                      _c("td", [
                        _c("span", { class: _vm.deadlineClass(row) }, [
                          _vm._v(_vm._s(_vm.deadlineLabel(row))),
                        ]),
                      ]),
                      _c(
                        "td",
                        { staticClass: "actions-cell" },
                        [
                          _c(
                            "vs-button",
                            {
                              attrs: { size: "small", type: "border" },
                              on: {
                                click: function ($event) {
                                  return _vm.openDetail(row.id)
                                },
                              },
                            },
                            [_vm._v("Abrir")]
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
      ]),
      _c(
        "vs-popup",
        {
          staticClass: "privacy-popup",
          attrs: { active: _vm.detailOpen, title: "Requisição do titular" },
          on: {
            "update:active": function ($event) {
              _vm.detailOpen = $event
            },
          },
        },
        [
          _vm.detail
            ? _c("div", { staticClass: "detail" }, [
                _c("div", { staticClass: "detail-head" }, [
                  _c("div", [
                    _c("h4", [
                      _vm._v(
                        "#" +
                          _vm._s(_vm.detail.id) +
                          " · " +
                          _vm._s(_vm.detail.type_label)
                      ),
                    ]),
                    _c("p", { staticClass: "detail-subject" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.detail.user ? _vm.detail.user.name : "—") +
                          " "
                      ),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.detail.user ? _vm.detail.user.email : "")
                        ),
                      ]),
                    ]),
                  ]),
                  _c(
                    "span",
                    {
                      staticClass: "pill",
                      class: _vm.statusClass(_vm.detail.status),
                    },
                    [_vm._v(_vm._s(_vm.detail.status_label))]
                  ),
                ]),
                _c("div", { staticClass: "detail-grid" }, [
                  _c("div", [
                    _c("label", [_vm._v("Aberta em")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.formatDate(_vm.detail.requested_at))),
                    ]),
                  ]),
                  _c("div", [
                    _c("label", [_vm._v("Prazo legal")]),
                    _c("span", { class: _vm.deadlineClass(_vm.detail) }, [
                      _vm._v(_vm._s(_vm.formatDate(_vm.detail.due_at))),
                    ]),
                  ]),
                  _vm.detail.handled_at
                    ? _c("div", [
                        _c("label", [_vm._v("Atendida em")]),
                        _c("span", [
                          _vm._v(_vm._s(_vm.formatDate(_vm.detail.handled_at))),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.detail.handler
                    ? _c("div", [
                        _c("label", [_vm._v("Responsável")]),
                        _c("span", [_vm._v(_vm._s(_vm.detail.handler.name))]),
                      ])
                    : _vm._e(),
                ]),
                _vm.detail.description
                  ? _c("div", { staticClass: "detail-block" }, [
                      _c("label", [_vm._v("O que o titular escreveu")]),
                      _c("p", [_vm._v(_vm._s(_vm.detail.description))]),
                    ])
                  : _vm._e(),
                _vm.isErasure(_vm.detail)
                  ? _c("div", { staticClass: "detail-warning" }, [
                      _c("strong", [_vm._v("Atenção — ação irreversível.")]),
                      _vm._v(
                        " Concluir esta requisição anonimiza a conta: nome, e-mail, CPF, telefone, endereço e foto são apagados, cartões removidos e sessões encerradas. Pedidos e pagamentos "
                      ),
                      _c("strong", [_vm._v("permanecem")]),
                      _vm._v(
                        ", sem vínculo com o titular, por obrigação legal (5 anos). "
                      ),
                    ])
                  : _vm._e(),
                _vm.detail.resolution_note
                  ? _c("div", { staticClass: "detail-block" }, [
                      _c("label", [_vm._v("Resolução")]),
                      _c("p", [_vm._v(_vm._s(_vm.detail.resolution_note))]),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "detail-block" }, [
                  _c("label", [_vm._v("Linha do tempo")]),
                  _c(
                    "ul",
                    { staticClass: "timeline" },
                    _vm._l(_vm.detail.events, function (event) {
                      return _c("li", { key: event.id }, [
                        _c("span", { staticClass: "timeline-when" }, [
                          _vm._v(_vm._s(_vm.formatDateTime(event.created_at))),
                        ]),
                        _c(
                          "span",
                          { staticClass: "timeline-what" },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.eventLabel(event.event))),
                            ]),
                            event.note
                              ? [_vm._v(" — " + _vm._s(event.note))]
                              : _vm._e(),
                            event.user
                              ? [_vm._v(" · " + _vm._s(event.user.name))]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ])
                    }),
                    0
                  ),
                ]),
                _vm.isOpen(_vm.detail)
                  ? _c(
                      "div",
                      { staticClass: "detail-actions" },
                      [
                        _c("vs-input", {
                          staticClass: "w-full mb-4",
                          attrs: {
                            label: "Observação (obrigatória para recusar)",
                            placeholder:
                              "Descreva o que foi feito ou o motivo da recusa",
                          },
                          model: {
                            value: _vm.resolutionNote,
                            callback: function ($$v) {
                              _vm.resolutionNote = $$v
                            },
                            expression: "resolutionNote",
                          },
                        }),
                        _c(
                          "div",
                          { staticClass: "action-buttons" },
                          [
                            _vm.detail.status === "PE"
                              ? _c(
                                  "vs-button",
                                  {
                                    attrs: {
                                      type: "border",
                                      disabled: _vm.working,
                                    },
                                    on: { click: _vm.startProcessing },
                                  },
                                  [_vm._v(" Marcar em processamento ")]
                                )
                              : _vm._e(),
                            _c(
                              "vs-button",
                              {
                                attrs: {
                                  color: "danger",
                                  type: "border",
                                  disabled: _vm.working,
                                },
                                on: { click: _vm.reject },
                              },
                              [_vm._v(" Recusar ")]
                            ),
                            _c(
                              "vs-button",
                              {
                                attrs: {
                                  color: _vm.isErasure(_vm.detail)
                                    ? "danger"
                                    : "primary",
                                  disabled: _vm.working,
                                },
                                on: { click: _vm.complete },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.isErasure(_vm.detail)
                                        ? "Executar anonimização"
                                        : "Concluir"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }